<div class="wrapper">
  <div class="content__wrapper">
    <div [attr.data-type]="datatype" *ngFor="let item of HighlightcardItems">
      <hdi-icon
        class="icon"
        [style.backgroundColor]="item.iconBgColor || Colors.BLUE"
        [size]="Sizes.XLARGE"
        [color]="Colors.WHITE"
        [iconName]="item.icontype"
      ></hdi-icon>
      <div
        class="content"
        [ngClass]="{ 'no-text': !item.inhalt }"
        *ngFor="let inhalt of item.inhalt; let i = index"
      >
        <h4
          class="content__headline"
          *ngIf="inhalt.headline"
          [innerHTML]="inhalt.headline"
        ></h4>
        <div
          class="content__text"
          [ngClass]="inhalt.contentClasses"
          *ngIf="inhalt.content"
          [innerHTML]="inhalt.content"
        ></div>
        <ng-container *ngIf="datatype === 'checklist'">
          <div class="checklist" *ngFor="let listitem of inhalt.checklist">
            <hdi-icon
              [iconName]="'check'"
              [iconPrefix]="'far'"
              [color]="Colors.GREEN_LOGO"
            >
            </hdi-icon>
            <li class="checklist__listitem" [innerHTML]="listitem.li"></li>
          </div>
        </ng-container>
        <ng-container *ngFor="let image of item.imageSrc; let i = index">
          <div
            class="checklist__image"
            *ngIf="image && image.trim().length > 0"
          >
            <hdi-image
              [src]="image"
              [alt]="item.imageAlt[i]"
              [title]="item?.imageTitle?.[i] ?? ''"
            ></hdi-image>
          </div>
        </ng-container>
        <ng-container *ngIf="datatype === 'infolist'">
          <hdi-icon
            class="icon"
            [style.backgroundColor]="item.iconBgColor || Colors.GREEN"
            [size]="Sizes.XLARGE"
            [color]="Colors.WHITE"
            [iconName]="item.icontype"
          ></hdi-icon>
          <div
            class="checklist__number"
            *ngFor="let number of inhalt.checklist; let i = index"
          >
            <li class="checklist__number__item">
              <span class="bold" [innerHTML]="i + 1 + '.'"></span>
              <span [innerHTML]="number.li"></span>
            </li>
          </div>
          <hdi-link
            *ngIf="item.cta"
            [type]="item.ctaType"
            [label]="item.ctaLabel | capitalize"
            [href]="item.ctaSrc"
          >
          </hdi-link>
        </ng-container>
      </div>
    </div>
  </div>
</div>
